import Marionette from 'backbone.marionette';
import billDetailAuthorCompositviewTmpl from '../templates/bill_detail_author_compositview.tpl';
import billDetailAuthorItemview from './bill_detail_author_itemview';
export default Marionette.CompositeView.extend({
  childView: billDetailAuthorItemview,
  template: billDetailAuthorCompositviewTmpl,
  childViewContainer: "#bill-coauthors"
});